var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"vue-skip-to__link",attrs:{"href":_vm.to},on:{"focus":function($event){return _vm.$emit('focused', true)},"blur":function($event){return _vm.$emit('focused', false)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }